import React from 'react'
import { Paper, makeStyles, Typography } from '@material-ui/core'

interface FormProps {
  title?: string
  handleSubmit?: () => void
  children: React.ReactNode
  className?: string
  style?: any
}

export const Form: React.FC<FormProps> = ({ title, handleSubmit, children, className, style }) => {
  const classes = useStyles()

  return (
    <Paper className={`${classes.formContainer} ${className}`} style={style}>
      <Typography color="primary" variant="h5" className={classes.title}>
        {title ? title : 'Insert Form Title as Prop'}
      </Typography>
      <form onSubmit={handleSubmit}>{children}</form>
    </Paper>
  )
}

const useStyles = makeStyles({
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 20
  },
  title: {
    marginBottom: 20
  },
  formField: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: 10
  },
  row: {
    display: 'flex'
  },
  submitButton: {
    marginTop: 30,
    width: 200
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
})
